<template>
  <div class="container">
    <span class="title">{{ titleOne }}</span>
    <TableOne
      :porcentajeFuncionariosCapacitados="porcentajeFuncionariosCapacitados"
      :readOnly="readOnly"
    />
    <span class="title">{{ titleTwo }}</span>
    <TableTwo :promedioAnualHoras="promedioAnualHoras" :readOnly="readOnly" />
    <span class="title">{{ titleThree }}</span>
    <TableThree
      :porcentajeActividades="porcentajeActividades"
      :readOnly="readOnly"
    />
    <span class="title">{{ titleFour }}</span>
    <TableFour :becasOrtogadas="becasOrtogadas" :readOnly="readOnly" />
  </div>
</template>

<script>
import TableOne from "./components/mainTableFour/TableOne.vue";
import TableTwo from "./components/mainTableFour/TableTwo.vue";
import TableThree from "./components/mainTableFour/TableThree";
import TableFour from "./components/mainTableFour/TableFour";
export default {
  props: [
    "porcentajeFuncionariosCapacitados",
    "promedioAnualHoras",
    "porcentajeActividades",
    "becasOrtogadas",
    "readOnly",
  ],
  components: {
    TableOne,
    TableTwo,
    TableThree,
    TableFour,
  },
  data() {
    return {
      //Primary Table
      titleOne:
        "4.1 Porcentaje de funcionarios capacitados, respecto de la Dotación Efectiva",
      encabezado: "Variables",
      textOne: "(a) N° de funcionarios capacitados año t",
      textTwo: "(b) Total Dotación Efectiva año t",
      textThree: "Porcentaje de funcionarios capacitados (a/b)",
      inputFour: "",
      inputOne: "",
      inputTwo: "",
      inputThree: "",
      inputFive: "",
      inputSix: "",

      //Second Table
      titleTwo:
        "4.2 Promedio anual de horas contratadas para Capacitación por funcionario",
      textTwoOne:
        "(a) ∑(N° horas contratadas en act. de capacitación año t * N° participantes capacitados en act. de capacitación año t)",
      textTwoTwo: "(b) Total de participantes capacitados año t",
      textTwoThree: "Promedio de horas de capacitación por funcionario (a/b)",
      inputTwoOne: "",
      inputTwoTwo: "",
      inputTwoThree: "",
      inputTwoFive: "",
      inputTwoSix: "",

      //Third Table
      titleThree:
        "4.3 Porcentaje de actividades de capacitación con evaluación de transferencia",
      textThreeOne:
        "(a) N° de actividades de capacitación con evaluación de transferencia  en el puesto de trabajo año t",
      textThreeTwo: "(b) N° de actividades de capacitación año t",
      textThreeThree:
        "Porcentaje de actividades con evaluación de transferencia (a/b)",
      inputThreeOne: "",
      inputThreeTwo: "",
      inputThreeThree: "",
      inputThreeFive: "",
      inputThreeSix: "",

      //Quarter Table

      titleFour:
        "4.4 Porcentaje de becas otorgadas respecto a la Dotación Efectiva",
      textFourOne: "(a) N° de becas  otorgadas año t",
      textFourTwo: "(b) Total Dotación Efectiva año t",
      textFourThree: "Porcentaje de becados (a/b)",
      inputFourOne: "",
      inputFourTwo: "",
      inputFourThree: "",
      inputFourFive: "",
      inputFourSix: "",
    };
  },
};
</script>

<style scoped>
.title {
  color: #052333;
  font-size: 17px;
  font-weight: bold;
  margin-top: 10px !important;
  margin-bottom: 10px;
}
</style>
